// @francesca - img are fine, link to drive folder here: t.ly/gCLF

export default {
  giftcard: {
    header: {
      title: 'Gift card as a top gift idea',
      subtitle:
        'The perfect gift: The gift card is redeemable for all konfetti classes',
      buttonLabel: 'Choose your giftcard',
      titleColor: '#FFFFFF',
      bgColor: '#61B0BC',
    },

    validity: 'Recipient chooses class and date',
    forAnyKonfetti: 'Redeemable for more than {eventCount} classes',
    experience: 'After purchase valid for three years',

    option_1: '30',
    option_2: '50',
    option_3: '100',
    option_4: '200',
    options: 'Buy a gift card',
    value: 'Pick a value',
    select: 'Popular values',
    input: 'Choose your own value',
    inputError: 'Please choose a value between 15€-200€ for your gift card',

    bookAction: 'Add to cart',

    mainContent: {
      one: {
        title: 'Give the gift of great experiences and good times',
        description:
          'Probably the most creative gift card: Give the gift of unique experiences and time together with konfetti. From action painting and Italian cooking to pottery on the wheel and cocktail tastings, konfetti has something for everyone.',
      },
      two: {
        title: 'The experience gift card that lets you learn from real experts',
        description:
          'Each course is led by real experts. With the konfetti gift card, you will meet sommeliers, chefs, artisans, artists and many others who are eager to share their passion.',
      },
      three: {
        title: 'The most creative last-minute gift: A gift card for courses',
        description:
          "A last-minute gift that shows you've really put some thought into it. Choose the gift card that best suits the recipient. The voucher will be emailed to you for printing or mailed as a gift card.",
      },
    },

    content: {
      title: 'Give special experiences this holiday season',
      icons: {
        one: {
          title: 'Set the value of the gift card',
          description:
            'From 15 to 500 euros - you decide the value of the gift card.',
        },
        two: {
          title: 'A personal last-minute-gift',
          description:
            'The gift card will be emailed to you immediately after your purchase.',
        },
        three: {
          title: 'Optional print gift card',
          description:
            'If you choose the gift card option, we will send it to your address the next business day.',
        },
        four: {
          title: 'Gift card for top classes',
          description:
            'Redeemable for more than {eventCount} classes. Germany-, Austria-wide and online.',
        },
      },
    },

    breadcrumb: {
      value: 'Giftcard',
    },

    bookingSolution: {
      gridTitle: 'Our gift card',
      gridSubtitle: 'Unique gift idea for a great experience',
      grid1: {
        title: 'Give the gift of experience',
        content:
          'Give your loved ones the gift of a special experience they will remember.',
      },
      grid2: {
        title: 'The perfect last-minute gift!',
        content:
          'You receive the gift card via mail. Print at home directly after checkout.',
      },
      grid3: {
        title: 'A gift for every budget',
        content: 'From 15 to 200 Euros - you pick the gift card amount.',
      },
      cardTags: 'Verschenke Zeit; Erlebnisse',
    },

    magazineTitle: 'Gift an experience',
  },
}
